(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.FacebookPrivatePost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Facebook private post data',
            channelName: sourceDetails[sources.FACEBOOK_INSIGHTS].name,
            postName: sourceDetails[sources.FACEBOOK_INSIGHTS].postName,

            storageDimensions: [
                'post_id'
            ],

            fields: {
                post_id: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                company_id: {
                    dataType: dataType.STRING
                },
                company_name: {
                    dataType: dataType.STRING
                },
                presence_handle: {
                    dataType: dataType.STRING
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                presence_reach: {
                    dataType: dataType.INTEGER
                },
                published_at: {
                    dataType: dataType.DATE
                },
                captured_at: {
                    dataType: dataType.DATE
                },
                message: {
                    dataType: dataType.STRING
                },
                post_url: {
                    dataType: dataType.STRING
                },
                media_type: {
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                admin_creator_name: {
                    dataType: dataType.STRING
                },
                reach: {
                    dataType: dataType.INTEGER
                },
                reach_organic: {
                    dataType: dataType.INTEGER
                },
                reach_paid: {
                    dataType: dataType.INTEGER
                },
                reach_organic_viral: {
                    dataType: dataType.INTEGER
                },
                reach_organic_non_viral: {
                    dataType: dataType.INTEGER
                },
                fan_reach: {
                    dataType: dataType.INTEGER
                },
                fan_reach_rate: {
                    dataType: dataType.NUMERIC
                },
                engagement_total: {
                    dataType: dataType.INTEGER
                },
                reactions: {
                    dataType: dataType.INTEGER
                },
                reactions_organic: {
                    dataType: dataType.INTEGER
                },
                reactions_paid: {
                    dataType: dataType.INTEGER
                },
                reactions_post_only: {
                    dataType: dataType.INTEGER
                },
                likes: {
                    dataType: dataType.INTEGER
                },
                likes_post_only: {
                    dataType: dataType.INTEGER
                },
                loves: {
                    dataType: dataType.INTEGER
                },
                loves_post_only: {
                    dataType: dataType.INTEGER
                },
                hahas: {
                    dataType: dataType.INTEGER
                },
                hahas_post_only: {
                    dataType: dataType.INTEGER
                },
                wows: {
                    dataType: dataType.INTEGER
                },
                wows_post_only: {
                    dataType: dataType.INTEGER
                },
                sads: {
                    dataType: dataType.INTEGER
                },
                sads_post_only: {
                    dataType: dataType.INTEGER
                },
                angrys: {
                    dataType: dataType.INTEGER
                },
                angrys_post_only: {
                    dataType: dataType.INTEGER
                },
                comments: {
                    dataType: dataType.INTEGER
                },
                comments_organic: {
                    dataType: dataType.INTEGER
                },
                comments_paid: {
                    dataType: dataType.INTEGER
                },
                comments_post_only: {
                    dataType: dataType.INTEGER
                },
                shares: {
                    dataType: dataType.INTEGER
                },
                shares_organic: {
                    dataType: dataType.INTEGER
                },
                shares_paid: {
                    dataType: dataType.INTEGER
                },
                shares_post_only: {
                    dataType: dataType.INTEGER
                },
                impressions: {
                    dataType: dataType.INTEGER
                },
                impressions_organic: {
                    dataType: dataType.INTEGER
                },
                impressions_paid: {
                    dataType: dataType.INTEGER
                },
                impressions_organic_viral: {
                    dataType: dataType.INTEGER
                },
                impressions_organic_non_viral: {
                    dataType: dataType.INTEGER
                },
                engaged_users: {
                    dataType: dataType.INTEGER
                },
                engaged_page_fans: {
                    dataType: dataType.INTEGER
                },
                engaged_non_page_fans: {
                    dataType: dataType.INTEGER
                },
                negative_feedback: {
                    dataType: dataType.INTEGER
                },
                negative_feedback_unique: {
                    dataType: dataType.INTEGER
                },
                fan_post_impressions: {
                    dataType: dataType.INTEGER
                },
                fan_post_impressions_paid: {
                    dataType: dataType.INTEGER
                },
                fan_reach_paid: {
                    dataType: dataType.INTEGER
                },
                video_viewers: {
                    dataType: dataType.INTEGER
                },
                video_viewers_organic: {
                    dataType: dataType.INTEGER
                },
                video_viewers_paid: {
                    dataType: dataType.INTEGER
                },
                video_views_organic: {
                    dataType: dataType.INTEGER
                },
                video_views_paid: {
                    dataType: dataType.INTEGER
                },
                video_views_30_second: {
                    dataType: dataType.INTEGER
                },
                video_views_30_second_organic: {
                    dataType: dataType.INTEGER
                },
                video_views_30_second_paid: {
                    dataType: dataType.INTEGER
                },
                video_views_10_second: {
                    dataType: dataType.INTEGER
                },
                video_views_10_second_organic: {
                    dataType: dataType.INTEGER
                },
                video_views_10_second_paid: {
                    dataType: dataType.INTEGER
                },
                video_views_to_95_percent: {
                    dataType: dataType.INTEGER
                },
                video_views_to_95_percent_organic: {
                    dataType: dataType.INTEGER
                },
                video_views_to_95_percent_paid: {
                    dataType: dataType.INTEGER
                },
                video_view_30_second_rate: {
                    dataType: dataType.NUMERIC
                },
                video_view_30_second_rate_organic: {
                    dataType: dataType.NUMERIC
                },
                video_view_30_second_rate_paid: {
                    dataType: dataType.NUMERIC
                },
                video_view_95_percent_rate: {
                    dataType: dataType.NUMERIC
                },
                video_view_95_percent_rate_organic: {
                    dataType: dataType.NUMERIC
                },
                video_view_95_percent_rate_paid: {
                    dataType: dataType.NUMERIC
                },
                live_video_viewers: {
                    dataType: dataType.INTEGER
                },
                views_reels_and_videos: {
                    dataType: dataType.NUMERIC
                },
                video_length_reels_and_videos: {
                    dataType: dataType.NUMERIC
                },
                total_time_viewed_reels_and_videos: {
                    dataType: dataType.NUMERIC
                },
                average_watch_length_reels_and_videos: {
                    dataType: dataType.NUMERIC
                },
                video_view_length_organic: {
                    dataType: dataType.NUMERIC
                },
                video_view_length_paid: {
                    dataType: dataType.NUMERIC
                },
                average_percent_viewed_video: {
                    dataType: dataType.NUMERIC
                },
                video_view_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_total: {
                    dataType: dataType.INTEGER
                },
                social_engagement_total_organic: {
                    dataType: dataType.INTEGER
                },
                social_engagement_total_paid: {
                    dataType: dataType.INTEGER
                },
                social_engagement_total_post_only: {
                    dataType: dataType.INTEGER
                },
                consumptions_via_insights: {
                    dataType: dataType.INTEGER
                },
                consumptions_via_ads: {
                    dataType: dataType.INTEGER
                },
                link_clicks_via_insights: {
                    dataType: dataType.INTEGER
                },
                link_clicks_via_ads: {
                    dataType: dataType.INTEGER
                },
                photo_views_via_insights: {
                    dataType: dataType.INTEGER
                },
                photo_views_via_ads: {
                    dataType: dataType.INTEGER
                },
                video_plays_via_insights: {
                    dataType: dataType.INTEGER
                },
                video_plays_via_ads: {
                    dataType: dataType.INTEGER
                },
                other_clicks_via_insights: {
                    dataType: dataType.INTEGER
                },
                other_clicks_via_ads: {
                    dataType: dataType.INTEGER
                },
                facebook_engagement_rate: {
                    dataType: dataType.INTEGER
                },
                total_spend: {
                    dataType: dataType.INTEGER
                },
                image_url: {
                    dataType: dataType.STRING
                },
                engagement_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_reach: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_presence_reach: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_reach: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_reach_organic: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_reach_paid: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_impression_organic: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_impression_paid: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_presence_reach: {
                    dataType: dataType.NUMERIC
                },
                post_tag_ids: {
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost, // TODO: rename publicPost into just post
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
